import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getDepositosPanel = async (searchTerm, searchIDFilter, numPagina, filas) => {
   let queryParams = [];
  
    if (searchTerm) {
      queryParams.push(`search=${encodeURIComponent(searchTerm || '')}`);
    }
    if (searchIDFilter) {
      queryParams.push(`filter=${encodeURIComponent(searchIDFilter)}`);
    }
    if (numPagina) {
      queryParams.push(`page=${encodeURIComponent(numPagina)}`);
    }
    if (filas) {
      queryParams.push(`perPage=${encodeURIComponent(filas)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return await getData("/depositos", queryString);
}
export const getDepositosLista = async () => {
    const res = await getData('/depositos');
    return res
}

export const getDepositoById = async (id) => {
    const res = await getData(`/depositos/${id}`)
    return res
}

export const postDeposito = async (body) => {
    const res = await postData('/depositos', body)
    return res
}

export const patchDeposito = async (id, body) => {
    const res = await patchData(`/depositos/${id}`, body)
    return res
}

export const deleteDeposito = async (id) => {
    const res = await deleteData(`/depositos/${id}`)
    return res
}